<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11eHH7t/tc-custom/9781449496623.jpg?1709161648555" alt="This image is the cover for the book Little Moments of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Moments of Love
      </h1>
      <p class="bookDescription body article font2">
        <p>What began as stray doodles on scraps of paper became an internet sensation when Catana Chetwynd’s boyfriend shared her drawings online. Now, Catana Comics touches millions of readers with its sweet, relatable humor. <i>Little Moments of Love</i> collects just that – the little moments that are the best parts of being with the person you love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catana Chetwynd
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a861a0fc